import DataGrid from 'react-data-grid';
import { Switch, Route, withRouter } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';

import CreateButton from 'components/ui/buttons/CreateButton';
import NoRecords from 'components/ui/DataGrid/NoRecords';
import SectorEditMenu from 'components/sectors/SectorEditMenu';
import withContentLoader from 'components/ui/withContentLoader';
import withAuthorizer from 'components/ui/withAuthorizer';
import NotificationHelper from 'helpers/NotificationHelper';

import { Resources } from 'helpers/ResourceHelper';

import SectorApi from 'api/sector';
import AlertHelper from 'helpers/AlertHelper';

import FormSectorPage from './FormSectorPage';

const SectorsTab = ({ data = [], match }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const mutationParams = {
    onSuccess: () => {
      queryClient.invalidateQueries('sectors');
    },
  };

  const deleteMutation = useMutation(async id => {
    try {
      await SectorApi.delete(id);
    } catch (error) {
      NotificationHelper.snack(t('admin.categories.errors.remove'));
    }
  }, mutationParams);

  const onRemove = async sector => {
    const result = await AlertHelper.confirmDanger({
      title: t('dialogs.remove.title'),
      text: t('dialogs.remove.description'),
    });

    if (result.value) {
      await deleteMutation.mutate(sector.id);
    }
  };

  const columns = [
    { key: 'name', name: t('columns.name') },
    { key: 'actions', name: '', width: 100, formatter: ({ row }) => <SectorEditMenu sector={row} onRemove={onRemove.bind(this, row)} /> },
  ];

  return (
    <>
      <DataGrid columns={columns} rows={data} className="data-grid rdg-light" rowName="row" rowHeight={60} emptyRowsRenderer={NoRecords} />
      <CreateButton to="/admin/sectors/new" />

      <Switch>
        <Route exact path="/admin/sectors/new" children={<FormSectorPage backUrl={match.url} />} sector={data} />
        <Route exact path="/admin/sectors/edit/:sectorId" children={<FormSectorPage backUrl={match.url} categories={data} />} />
      </Switch>
    </>
  );
};

const fetchData = async () => SectorApi.fetch();
const page = withContentLoader(SectorsTab, { name: 'sectors', fetchData });
export default withRouter(withAuthorizer(page, [Resources.sector_MANAGER]));
